import { render, staticRenderFns } from "./ChatSelector.vue?vue&type=template&id=5ead8daf&scoped=true"
import script from "./ChatSelector.vue?vue&type=script&lang=js"
export * from "./ChatSelector.vue?vue&type=script&lang=js"
import style0 from "./ChatSelector.vue?vue&type=style&index=0&id=5ead8daf&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ead8daf",
  null
  
)

export default component.exports